"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EqualCountBySignRaster = void 0;
const sortedLastIndex_1 = __importDefault(require("lodash/sortedLastIndex"));
const raster_1 = require("./raster");
const helpers_1 = require("./helpers");
class EqualCountBySignRaster extends raster_1.Raster {
    constructor(data, bounds, colorRange, options) {
        super(data, bounds, colorRange, options);
        this.ranges = this.computeRanges();
        this.imageData = this.computeImagedata();
    }
    computeRanges() {
        /*
          Buckets and sorts numerically, such that
          all non-positive values are bucketed by equal count (equally distributed)
          and all positive values are bucketed by equal count (equally distributed).
        */
        const { positiveBucketCount, nonPositiveBucketCount } = this.options;
        if (!positiveBucketCount || !nonPositiveBucketCount) {
            throw new Error("Please specify a positiveBucketCount and nonPositiveBucketCount that's greater than 0");
        }
        if (positiveBucketCount + nonPositiveBucketCount !== this.colors.length) {
            throw new Error("The sum of positiveBucketCount and nonPositiveBucketCount must be equal to the number of colors");
        }
        // Find the last index where 0 can be inserted into the sorted array.
        // This is the first index where a positive value can be found.
        const ordered = this.orderedValues;
        const firstPositiveValueIndex = (0, sortedLastIndex_1.default)(ordered, 0);
        const positiveValues = ordered.slice(firstPositiveValueIndex);
        const nonPositiveValues = ordered.slice(0, firstPositiveValueIndex);
        // The number of positive and non-positive values
        const numberOfPositiveValues = positiveValues.length;
        const numberOfNonPositiveValues = nonPositiveValues.length;
        // Bucket by non-positive values
        let nonPositiveBucketsEdges = [];
        if (numberOfNonPositiveValues === 0) {
            // If the entire field is profitable,
            // set the unprofitable bucket edges to all zeros
            nonPositiveBucketsEdges = new Array(nonPositiveBucketCount).fill(0);
        }
        else {
            nonPositiveBucketsEdges = (0, helpers_1.bucketByEqualCount)(nonPositiveValues, nonPositiveBucketCount);
        }
        // Bucket by positive values
        let positiveBucketsEdges = [];
        if (numberOfPositiveValues === 0) {
            // If the entire field is unprofitable,
            // set the profitable bucket edges to all zeros
            positiveBucketsEdges = new Array(positiveBucketCount).fill(0);
        }
        else {
            positiveBucketsEdges = (0, helpers_1.bucketByEqualCount)(positiveValues, positiveBucketCount);
        }
        // The buckets are:
        // 0) all negative bucket edges, up to *<last negative bucket edge>*
        // 1) <last negative bucket edge> up to *0*
        // 2) 0 up to *<first positive bucket edge>*
        // 3) <first positive bucket edge> up to *<second positive bucket edge>*
        // n) and so on ... up to *<highest positive value>*
        return [
            ...nonPositiveBucketsEdges.slice(0, -1),
            0,
            ...positiveBucketsEdges,
        ];
    }
}
exports.EqualCountBySignRaster = EqualCountBySignRaster;
